var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"telemetry-event-overlay"},[_c('div',{staticClass:"overlay justify-content-center align-items-center d-flex",class:{
        'd-flex': _vm.eventProcessing,
        'd-none': !_vm.eventProcessing
      }},[(_vm.eventName !== null)?_c(_vm.currentRawDataComponent,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }